import React, { FC } from 'react'

// Types
import { Gutter, GridProps } from './Grid.types'

// Styles
import { Container } from './Grid.styles'

// Constants
const DEFAULT_GUTTER: Gutter = {
  xl: 40,
  lg: 20,
  md: 20,
  sm: 20,
  xs: 16,
}

const Grid: FC<GridProps> = ({
  children,
  gutter = DEFAULT_GUTTER,
  ...props
}) => {
  return (
    <Container gutter={gutter} {...props}>
      {children}
    </Container>
  )
}

export default Grid
